<template>
  <el-tabs v-model="activeTab" class="top-tabs">
    <el-tab-pane label="创意素材" name="first">
      <el-form label-width="100px" label-position="left" class="drawer-tabs-content">
        <div class="title-text">基本信息</div>
        <MediaBaseInfo :mediaModel="mediaModel" />
        <el-row v-if="mediaModel.scheduleSource === 0">
          <el-col>
            <el-form-item label="展示方式">{{ exposureModeObj[mediaModel.exposureMode] }}</el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="mediaModel.scheduleSource !== 0 && mediaModel.supportMode === 0">
          <el-col>
            <el-form-item label="打底素材">{{ mediaModel.backup ===1? "是":"否" }}</el-form-item>
          </el-col>
        </el-row>
        <template v-if="mediaModel.minIcon">
          <div class="title-text">封面图</div>
          <el-image :src="mediaModel.minIcon" :preview-src-list="[mediaModel.minIcon]" style="width:300px;background-color:#3e649a;"></el-image>
        </template>
        <template v-if="mediaModel.bgIcon">
          <div class="title-text">背景图</div>
          <el-image :src="mediaModel.bgIcon" :preview-src-list="[mediaModel.bgIcon]" style="width:300px;background-color:#3e649a;"></el-image>
        </template>
        <template v-if="mediaModel.guideIcon">
          <div class="title-text">弹窗引导图</div>
          <el-image :src="mediaModel.guideIcon" :preview-src-list="[mediaModel.guideIcon]" style="width:300px"></el-image>
        </template>
        <template v-if="mediaModel.tipsDetail && mediaModel.tipsDetail.length">
          <div class="title-text">广告提示语</div>
          <el-card
            class="content-box"
            shadow="never"
            :body-style="{ padding: 0 }"
            :header="convertTempName(mediaModel.tipsTempId)"
          >
            <AdTipsDetail :tipsDetail="JSON.parse(mediaModel.tipsDetail)" />
          </el-card>
        </template>
        <template v-if="exsitEvent">
          <div class="title-text">交互事件</div>
          <TargetEvent
            :keyEventList="mediaModel.keyEventList"
            :autoEventList="mediaModel.autoEventList"
            :voiceEventList="mediaModel.voiceEventList"
            :disabled="true"
          />
        </template>
        <template v-if="exsitTracks">
          <div class="title-text">监测代码</div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="监测代码">{{ codeTypeObj[mediaModel.shareTrack] }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结算监测">
                {{ settlementTypeObj[mediaModel.settlementType] + ' ' + mediaModel.settlementProvider }}
              </el-form-item>
            </el-col>
          </el-row>
          <TrackCodeDetail showType title="曝光监测" :trackList="mediaModel.trackList" />
          <TrackCodeDetail showType title="点击监测" :trackList="mediaModel.clickTrackList" />
          <TrackCodeDetail showType title="起播监测" :trackList="mediaModel.startTrackList" />
          <TrackCodeDetail showType title="中点监测" :trackList="mediaModel.middleTrackList" />
          <TrackCodeDetail showType title="结束监测" :trackList="mediaModel.endTrackList" />
          <TrackCodeDetail showType title="定点监测" :trackList="mediaModel.pointTrackList" />
        </template>
        <template v-if="mediaModel.mobileTrackList && mediaModel.mobileTrackList.length > 0">
          <div class="title-text">移动端监测</div>
          <TrackCodeDetail hideHeader :trackList="mediaModel.mobileTrackList" />
        </template>
        <div class="title-text">媒体方</div>
        <Table
          v-loading="saveMediaLoading"
          :props="cableChannelTable.props"
          :header="cableChannelTable.header"
          :data="mediaModel.mediaCableChannelList"
        />
        <div class="title-text">牌照方</div>
        <Table
          v-loading="saveLicenseLoading"
          :props="licenseTable.props"
          :header="licenseTable.header"
          :data="mediaModel.licenseMediaList"
        />
        <template v-if="mediaModel.feedContent">
          <div class="title-text">附加创意</div>
          <el-row v-if="mediaModel.feedContent.creativeTitle">
            <el-col>
              <el-form-item label="创意标题">{{ mediaModel.feedContent.creativeTitle }}</el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="mediaModel.feedContent.clickButtonContent">
            <el-col>
              <el-form-item label="点击按钮文案">{{ mediaModel.feedContent.clickButtonContent }}</el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="exsitBackupEvent">
          <div class="title-text">打底交互事件</div>
          <TargetEvent
            :keyEventList="mediaModel.backupKeyEventList"
            :autoEventList="mediaModel.backupAutoEventList"
            :voiceEventList="mediaModel.backupVoiceEventList"
            :disabled="true"
          />
        </template>
        <template v-if="exsitLandingTacks">
          <div class="title-text">落地页监测代码</div>
          <TrackCodeDetail title="曝光监测" :trackList="mediaModel.trackListLanding" />
          <TrackCodeDetail title="点击监测" :trackList="mediaModel.clickTrackListLanding" />
          <TrackCodeDetail title="起播监测" :trackList="mediaModel.startTrackListLanding" />
          <TrackCodeDetail title="中点监测" :trackList="mediaModel.middleTrackListLanding" />
          <TrackCodeDetail title="结束监测" :trackList="mediaModel.endTrackListLanding" />
        </template>
        <template v-if="landingTips && landingTips.content">
          <div class="title-text">落地页提示语</div>
          <el-card
            class="content-box"
            shadow="never"
            :body-style="{ padding: 0 }"
          >
            <AdTipsDetail :show-text-style="false" :tips-detail="[landingTips]" />
          </el-card>
        </template>
      </el-form>
    </el-tab-pane>
    <el-tab-pane
      v-if="mediaModel.additionalMediaList && mediaModel.additionalMediaList.length"
      :label="`附加素材(${mediaModel.additionalMediaList.length})`"
      name="second"
    >
      <AdditionalMediaDetail :mediaList="additionalMediaDetail" :spaceTempList="spaceTempList" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import TrackCodeDetail from './TrackCodeDetail.vue'
import TargetEvent from '@/components/targetEvent/index.vue'
import MediaBaseInfo from '@/components/media/MediaBaseInfo.vue'
import AdTipsDetail from '@/components/media/AdTipsDetail.vue'
import AdditionalMediaDetail from './AdditionalMediaDetail.vue'
import {
  exposureModeObj,
  codeTypeObj,
  settlementTypeObj,
  trackTypeModelObj,
  trackOptions,
} from '../MaterialCreative'

export default {
  components: {
    TrackCodeDetail,
    TargetEvent,
    MediaBaseInfo,
    AdTipsDetail,
    AdditionalMediaDetail,
  },
  props: {
    mediaModel: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeTab: 'first',
      cableChannelTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '媒体方',
            align: 'center',
            prop: 'cableChannelName',
            'show-overflow-tooltip': true
          },
          {
            label: '推送状态',
            align: 'center',
            prop: 'pushStatus',
            'show-overflow-tooltip': true,
            formatter: params => {
              return ['未推送', '已推送', '推送失败'][params.pushStatus] || '-'
            }
          },
          {
            label: '审核状态',
            align: 'center',
            prop: 'checkStatus',
            'show-overflow-tooltip': true,
            formatter: params => {
              return ['待审核', '已审核', '审核不通过'][params.checkStatus] || '-'
            }
          },
          {
            'render-header': row => {
              return (
                <div>
                  <span>DealId</span>
                  <el-tooltip content="此ID仅与咪咕订单交易时使用" effect="light" placement="top">
                    <i class="el-icon-question grid-tooltip-icon"></i>
                  </el-tooltip>
                </div>
              )
            },
            align: 'center',
            prop: 'dealId',
            'show-overflow-tooltip': true,
          },
          {
            label: '播放串',
            align: 'left',
            prop: 'playCode',
            'show-overflow-tooltip': true,
            formatter: row => {
              return row.playCode ? row.playCode : '-'
            }
          },
          {
            label: '未通过原因',
            align: 'left',
            prop: 'checkRemark',
            'show-overflow-tooltip': true
          },
          {
            label: '操作',
            align: 'center',
            prop: 'operate',
            render: (h, { row }) => {
              return h(
                'el-button',
                {
                  props: { type: 'text', disabled: row.disabled },
                  style: {
                    display: (row.pushStatus === 0 || row.pushStatus === 2) ? 'inline' : 'none'
                  },
                  on: {
                    click: event => {
                      event.stopPropagation()
                      row.disabled = true
                      this.handleCableApprove(row)
                    }
                  }
                },
                '提交审核'
              )
            }
          }
        ],
        data: []
      },
      licenseTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '牌照方',
            align: 'center',
            prop: 'licenseName',
            'show-overflow-tooltip': true
          },
          {
            label: '推送状态',
            align: 'center',
            prop: 'pushStatus',
            'show-overflow-tooltip': true,
            formatter: row => {
              return ['未推送', '已推送', '推送失败'][row.pushStatus] || '-'
            }
          },
          {
            label: '审核状态',
            align: 'center',
            prop: 'checkStatus',
            'show-overflow-tooltip': true,
            formatter: row => {
              return ['待审核', '审核通过', '已拒绝'][row.checkStatus] || '-'
            }
          },
          {
            label: '未通过原因',
            align: 'left',
            prop: 'description',
            'show-overflow-tooltip': true
          },
          {
            label: '补充信息',
            align: 'left',
            prop: 'extraMessage',
            'show-overflow-tooltip': true
          },
          {
            label: '更新时间',
            align: 'left',
            prop: 'updateTime',
            'show-overflow-tooltip': true
          },
          {
            label: '操作',
            align: 'center',
            prop: 'operate',
            render: (h, { row }) => {
              return h(
                'el-button',
                {
                  props: { type: 'text', disabled: row.disabled },
                  style: {
                    display: row.pushStatus === 2 ? 'inline' : 'none'
                  },
                  on: {
                    click: event => {
                      event.stopPropagation()
                      row.disabled = true
                      this.pushLicenseMedia(row)
                    }
                  }
                },
                '提交送审'
              )
            }
          }
        ],
        data: []
      },
      saveMediaLoading: false,
      saveLicenseLoading: false,
      spaceTempList: [],
      exposureModeObj,
      codeTypeObj,
      settlementTypeObj,
      trackTypeModelObj,
    }
  },
  computed: {
    landingTips() {
      const landingTipsDetail = (this.mediaModel.landingTipsDetail && this.mediaModel.landingTipsDetail.length)
        ? this.mediaModel.landingTipsDetail[0]
        : ''
      return landingTipsDetail ? JSON.parse(landingTipsDetail) : {}
    },
    exsitEvent() {
      return (this.mediaModel.keyEventList && this.mediaModel.keyEventList[0].targetTempId > -1) ||
        (this.mediaModel.voiceEventList && this.mediaModel.voiceEventList[0].targetTempId > -1) ||
        (this.mediaModel.autoEventList && this.mediaModel.autoEventList[0].targetTempId > -1)
    },
    exsitBackupEvent() {
      return (this.mediaModel.backupKeyEventList && this.mediaModel.backupKeyEventList[0].targetTempId > -1) ||
        (this.mediaModel.backupVoiceEventList && this.mediaModel.backupVoiceEventList[0].targetTempId > -1) ||
        (this.mediaModel.backupAutoEventList && this.mediaModel.backupAutoEventList[0].targetTempId > -1)
    },
    exsitTracks() {
      return trackOptions.some(option => {
        return this.mediaModel[option.key] && this.mediaModel[option.key].length > 0
      })
    },
    exsitLandingTacks() {
      return trackOptions.some(option => {
        if (option.key === 'pointTrackList') return false
        const key = option.key + 'Landing'
        return this.mediaModel[key] && this.mediaModel[key].length > 0
      })
    },
    additionalMediaDetail() {
      if (!this.mediaModel.additionalMediaList) return
      return this.mediaModel.additionalMediaList.map(item => {
        item.duration = (item.mediaDetailList && item.mediaDetailList.length) ? item.mediaDetailList[0].duration : undefined
        item.adSpaceName = this.mediaModel.adSpaceName
        item.partnerName = this.mediaModel.partnerName
        item.orderName = this.mediaModel.orderName
        item.scheduleName = this.mediaModel.scheduleName
        return item
      })
    },
  },
  created() {
    this.getTipsTempList()
  },
  methods: {
    getTipsTempList() {
      if (!this.mediaModel.spaceId) {
        return
      }
      this.$service.getAdTempTips({ spaceId: this.mediaModel.spaceId }).then((res) => {
        this.spaceTempList = res || []
      })
    },
    handleCableApprove(row) {
      const param = {
        cableChannelMediaId: row.cableChannelMediaId
      }
      this.saveMediaLoading = true
      this.$service.cableChannelApprove(param).then(res => {
        this.saveMediaLoading = false
        if (res.code === 0) {
          row.disabled = false
          this.$emit('reload-content')
          this.$message.success('提交审核成功')
        }
      }).catch(res => {
        this.saveMediaLoading = false
      })
    },
    pushLicenseMedia(row) {
      this.saveLicenseLoading = true
      this.$service.pushLicenseMedia(row.licenseMediaId).then(res => {
        this.saveLicenseLoading = false
        if (res.code === 0) {
          row.disabled = false
          this.$emit('reload-content')
          this.$message.success('提交送审成功')
        } else {
          this.$message.error(res.errorMsg)
        }
      }).catch(res => {
        this.saveLicenseLoading = false
      })
    },
    convertTempName(tipsTempId) {
      const spaceTemp = this.spaceTempList.find(item => item.tempId === tipsTempId)
      return spaceTemp ? spaceTemp.tempName : '自定义'
    }
  }
}
</script>

<style lang="stylus" scoped>
.drawer-tabs-content
  margin 0 16px
.el-form-item
  margin-bottom 0
.box-card >>>.el-card__header
  padding 13px 20px
.track-code >div
  font-size 14px
  margin-right 20px
  margin-bottom 10px
.top-tabs >>> >.el-tabs__header
  margin-bottom 0
  padding 0 16px
</style>
